<ng-container *ngIf="dialogService.state$ | async as dialog">
  <div *ngIf="dialog.isOpen" class="dialog-overlay" (click)="close(false)">
    <div class="dialog-shell" [class.danger]="dialog.variant === 'danger'" (click)="$event.stopPropagation()">
      <div class="dialog-badge">{{ dialog.mode === 'confirm' ? 'Conferma' : 'Messaggio' }}</div>
      <h3>{{ dialog.title }}</h3>
      <p>{{ dialog.message }}</p>
      <div class="dialog-actions">
        <button *ngIf="dialog.mode === 'confirm'" class="dialog-btn ghost" type="button" (click)="close(false)">
          {{ dialog.cancelLabel || 'Annulla' }}
        </button>
        <button class="dialog-btn primary" [class.danger]="dialog.variant === 'danger'" type="button" (click)="close(true)">
          {{ dialog.confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
